import { TDraggableItems } from './types'
import { pixelsToSeconds } from 'utils/timeline'

export const findElementByDataId = (
  dataId: string,
  container?: Element
): HTMLDivElement => {
  const searchRoot = container || document
  return searchRoot.querySelector(`[data-id="${dataId}"]`) as HTMLDivElement
}

export const getClampedDeltaX = (
  deltaX: number,
  draggableItems: TDraggableItems
): number => {
  const { maxLeft, minRight } = draggableItems.reduce(
    (acc, { leftBoundary, rightBoundary }) => ({
      maxLeft: Math.max(acc.maxLeft, leftBoundary),
      minRight: Math.min(acc.minRight, rightBoundary)
    }),
    { maxLeft: -Infinity, minRight: Infinity }
  )

  return deltaX < 0 ? Math.max(deltaX, maxLeft) : Math.min(deltaX, minRight)
}

const updateItemsPosition = (
  deltaX: number,
  draggableItems: TDraggableItems
) => {
  draggableItems.forEach(item => {
    const { node, left } = item
    const newLeft = left + deltaX
    if (node) {
      node.style.left = `${newLeft}px`
    }
  })
}

export const moveActiveItems = (
  deltaX: number,
  draggableItems: TDraggableItems
) => {
  // Calculate the clamped deltaX value based on the maximum allowed movement
  const clampedDeltaX = getClampedDeltaX(deltaX, draggableItems)
  updateItemsPosition(clampedDeltaX, draggableItems)

  // Return whether movement is still possible
  const canMoveLeft = deltaX < 0 && clampedDeltaX === deltaX
  const canMoveRight = deltaX > 0 && clampedDeltaX === deltaX

  const isScrollDisabled = !canMoveLeft && !canMoveRight

  return isScrollDisabled
}

export const getUpdatedItems = (
  draggableItems: TDraggableItems,
  timelineRulerSliceDuration: number
) => {
  return draggableItems.map(item => {
    const { node } = item
    return {
      id: item.id,
      type: item.type,
      left: node
        ? pixelsToSeconds(node.offsetLeft, timelineRulerSliceDuration)
        : 0
    }
  })
}

export const getDraggableItemsBounds = (draggableItems: TDraggableItems) => {
  if (draggableItems.length === 0) {
    return { maxLeft: 0, minRight: 0 }
  }

  return draggableItems.reduce(
    (acc, item) => ({
      maxLeft: Math.min(acc.maxLeft, item.left), // leftmost position (minimum left)
      minRight: Math.max(acc.minRight, item.right) // rightmost position (maximum right)
    }),
    {
      maxLeft: draggableItems[0].left,
      minRight: draggableItems[0].right
    }
  )
}
